import { render, staticRenderFns } from "./exam-request-picker.vue?vue&type=template&id=24958a52&"
import script from "./exam-request-picker.vue?vue&type=script&lang=js&"
export * from "./exam-request-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports